import React, { useEffect, useRef } from 'react';
import { Box } from '@mui/material';

export default function AgingCard() {
  const chartRef = useRef(null);
  const initialized = useRef(false);

  useEffect(() => {
    if (initialized.current) return;
    initialized.current = true;

    if (chartRef.current && typeof window.finAgingChart !== 'undefined') {
      window.finAgingChart.canvas = chartRef.current;
      window.finAgingChart.ctx = chartRef.current.getContext('2d');
    }
  }, []);

  return (
    <Box className="card" style={{ minHeight: '300px' }}>
      <div className="card-head">
        <h3 className="card-title">AP Aging</h3>
        <span className="click-tag">Click bars to filter</span>
      </div>
      <div className="chart-wrap" style={{ height: '240px' }}>
        <canvas id="finAgingChart" ref={chartRef}></canvas>
      </div>
      <div id="finExceptionGrid" className="exception-grid" style={{ marginTop: 16 }}></div>
    </Box>
  );
}
